import { Col } from '../layout';
export default Col;



// WEBPACK FOOTER //
// ./_antd1.11.2/col/index.js